import { createIcon } from "@chakra-ui/react";

export const ArrowRight = createIcon({
  displayName: "ArrowRight",
  viewBox: "0 0 24 24",
  d: "M22.56 13.06a1.502 1.502 0 0 0 0-2.124l-7.5-7.5a1.502 1.502 0 0 0-2.124 2.123L17.88 10.5H3.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h14.377l-4.936 4.94a1.502 1.502 0 0 0 2.123 2.124l7.5-7.5-.005-.005z",
  defaultProps: {
    "aria-label": "An arrow pointing right"
  }
});

export default ArrowRight;
